import React from 'react';

const CylinderShape = ({ shapeId, elementProperties = {} }) => {
  const {
    isTransparent = false,
    strokeWidth = 1,
    backgroundColor = "#cccccc",
    borderColor = "#333333",
    strokeUnit = "",
    opacity = 100,
  } = elementProperties;

  const fillColor = isTransparent ? "none" : backgroundColor;
  const strokeW = `${strokeWidth}${strokeUnit}`;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 160"
      preserveAspectRatio="none"
      id={shapeId}
      style={{ opacity: opacity / 100 }}
    >
      {/* Top ellipse */}
      <ellipse
        cx="50"
        cy="15"
        rx="40"
        ry="12"
        fill={fillColor}
        stroke={borderColor}
        strokeWidth={strokeW}
        id={`${shapeId}-top`}
      />

      {/* Cylinder body using curved paths */}
      <path
        d="M10,15 a40,12 0 0,0 80,0 L90,145 a40,12 0 0,0 -80,0 Z"
        fill={fillColor}
        stroke={borderColor}
        strokeWidth={strokeW}
        id={`${shapeId}-body`}
      />

      {/* Bottom ellipse back part */}
      <ellipse
        cx="50"
        cy="145"
        rx="40"
        ry="12"
        fill={fillColor}
        stroke={borderColor}
        strokeWidth={strokeW}
        id={`${shapeId}-bottom-back`}
        opacity="0.5"
      />

      {/* Bottom ellipse front outline */}
      <path
        d="M10,145 a40,12 0 0,0 80,0"
        fill="none"
        stroke={borderColor}
        strokeWidth={strokeW}
        id={`${shapeId}-bottom-front`}
      />
    </svg>
  );
};

export default CylinderShape;
